import React, { useEffect, useState, useMemo } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

function App() {
  const [engineInitialized, setEngineInitialized] = useState(false);
  const [selectedClient, setSelectedClient] = useState("premier");

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setEngineInitialized(true);
    });
  }, []);

  const particlesOptions = useMemo(
    () => ({
      background: {
        color: {
          value: "#000",
        },
      },
      fpsLimit: 60,
      interactivity: {
        events: {
          onHover: {
            enable: true,
            mode: "grab",
          },
          onClick: {
            enable: true,
            mode: "push",
          },
          resize: true,
        },
        modes: {
          grab: {
            distance: 140,
            links: {
              opacity: 1,
            },
          },
          push: {
            quantity: 4,
          },
        },
      },
      particles: {
        color: {
          value: "#ffffff",
        },
        links: {
          color: "#ffffff",
          distance: 150,
          enable: true,
          opacity: 0.4,
          width: 1,
        },
        move: {
          enable: true,
          speed: 6,
          direction: "none",
          random: false,
          straight: false,
          outModes: {
            default: "out",
          },
        },
        number: {
          density: {
            enable: true,
            area: 800,
          },
          value: 80,
        },
        opacity: {
          value: 0.5,
        },
        shape: {
          type: "circle",
        },
        size: {
          value: 3,
          random: true,
        },
      },
      detectRetina: true,
    }),
    []
  );

  if (!engineInitialized) {
    return null;
  }

  const handleRedirect = () => {
    if (selectedClient === "premier") {
      window.location.href = "/premier";
    } else if (selectedClient === "m-square") {
      window.location.href = "/m-square";
    }
  };

  return (
    <div style={{ position: "relative", height: "100vh", margin: 0 }}>
      {/* Particles Background */}
      <Particles id="tsparticles" options={particlesOptions} />
      {/* Main Content */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          color: "#fff",
          padding: "80px",
          maxWidth: "600px",
          textAlign: "left",
        }}
      >
        <h1 style={{ fontSize: "4rem", marginBottom: "20px" }}>
          Welcome to Neuract:
        </h1>
        <p style={{ fontSize: "1.5rem", marginBottom: "30px" }}>
          Empowering your energy management for a smarter, greener future.
        </p>
        <div>
          <select
            value={selectedClient}
            onChange={(e) => setSelectedClient(e.target.value)}
            style={{
              padding: "10px",
              fontSize: "1rem",
              marginRight: "10px",
              borderRadius: "4px",
              border: "none",
            }}
          >
            <option value="premier">Premier</option>
            <option value="m-square">M-square</option>
          </select>
          <button
            onClick={handleRedirect}
            style={{
              padding: "10px 20px",
              fontSize: "1rem",
              cursor: "pointer",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#6b3ceb",
              color: "#fff",
            }}
          >
            Go
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
